export default __webpack_public_path__ + "static/media/litho-demo-architecture.08159a8b.jpg";